import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ErrorText from './ErrorText';
import Icon from '../Icons/Icon';
import Button from '../Buttons/Button';
import DeleteButton from '../Buttons/DeleteButton';
import SelectDiagramImageModal from '../../Diagram/SelectDiagramImageModal';
import Label from './Label';

export default class DiagramImageSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diagram: null,
      imageAdded: false,
      modalOpen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Check to make sure the image has been populated
    if ('value' in nextProps) {
      if (nextProps.value !== undefined) {
        if (nextProps.value.src !== '') {
          this.setState({ imageAdded: true });
        } else {
          this.setState({ imageAdded: false });
        }
      }
    }
  }

  handleSelectDiagramClick = (diagram) => {
    this.props.onChange(diagram);
    this.setState({ diagram });
  }

  removeImage = (e) => {
    e.preventDefault();
    this.setState({ diagram: null }, () => {
      this.props.onChange(this.state.diagram);
    });
  }

  openModal = (e) => {
    e.preventDefault();
    this.setState({ modalOpen: true });
  }

  closeModal = () => {
    this.setState({ modalOpen: false });
  }

  render() {
    const { name, label, value, children, error, touched } = this.props;
    const { modalOpen } = this.state;

    const wrapperClass = classNames('image-upload-input-container upload-diagram', {
      'form-group--has-error': touched && error,
      'image-added': this.state.imageAdded,
    });

    return (
      <div className={wrapperClass}>
        <Label name={name}>{label}</Label>

        {children}

        {this.state.imageAdded &&
          <div className="image-upload-preview">
            <DeleteButton onClick={(e) => { this.removeImage(e); }} />
            <img alt="" src={value.src} />
          </div>
        }

        <div className="image-upload-container">
          <Button classes="image-upload-btn btn btn--tertiary w-100" onClick={e => this.openModal(e)}>
            <Icon name="outline-diagram" size="m" fill="grey" />
            <p className="m-b-0 fw-normal">Click to select from your diagrams</p>
          </Button>
        </div>

        <SelectDiagramImageModal
          modalIsOpen={modalOpen}
          closeModal={this.closeModal}
          onSelectDiagramClick={this.handleSelectDiagramClick}
        />

        {touched && error && <ErrorText>{error}</ErrorText>}
      </div>
    );
  }
}

DiagramImageSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/DiagramImageSelect.js